const paths = {
    backgrounds: `${process.env.PUBLIC_URL}/img/backgrounds`,
    characterTokens: `${process.env.PUBLIC_URL}/img/characters`,
    reminderTokens: `${process.env.PUBLIC_URL}/img/reminders`,
};
export default paths;
